module.exports = __webpack_public_path__ + "static/media/map_station_icon.8491ab32.svg";